import { render, staticRenderFns } from "./AssignmentDutiesList.vue?vue&type=template&id=8cfa726a"
import script from "./AssignmentDutiesList.vue?vue&type=script&lang=js"
export * from "./AssignmentDutiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports